import { camelizeKeys } from 'humps'
import { useGet, UseGetProps } from 'restful-react'
import { IDriverLocation } from 'types/Location'
import { getApiUrl } from 'utils/api/apiHelpers'
import { ENDPOINTS } from 'utils/api/callApi'

export interface IGetShipmentLocationsParams {
  shipmentId: string
}

interface IGetShipmentLocationsResponse {
  shipmentLocations: IDriverLocation[]
}

export type IUseGetShipmentLocationsProps = Omit<
  UseGetProps<IGetShipmentLocationsResponse, unknown, void, IGetShipmentLocationsParams>,
  'path'
> &
  IGetShipmentLocationsParams

/**
 * Gets driver location paths for a shipment
 * TODO: FP-2872 Deprecate this hook following ELD OM2 release
 */
export const useGetShipmentLocations = ({ shipmentId, ...props }: IUseGetShipmentLocationsProps) =>
  useGet<IGetShipmentLocationsResponse, unknown, void, IGetShipmentLocationsParams>(
    paramsInPath => `/${ENDPOINTS.fleetPlannerShipments}/${paramsInPath.shipmentId}/locations`,
    /**
     * Override the `base` prop with stark __API__ string
     */
    {
      pathParams: { shipmentId },
      base: getApiUrl('MARKETPLACE'),
      resolve: res => (camelizeKeys(res) as unknown) as IGetShipmentLocationsResponse,
      ...props,
    }
  )
